module.exports = __webpack_public_path__ + "img/border_leftTriangle.9521471d.svg";